import LocationPicker from "./location-picker.component";

export default LocationPicker;
